export default __webpack_public_path__ + "static/media/2-3-2.93e12530.jpg";